//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Annotations/Annotations.AnnotationManager.js";
let d=[[],[[["master_file_name"],"NewCustomSymbolData",{R_:{custom_symbol_data:"Annotations.CustomSymbolData"}},1,1],[["part_symbol_name"],"NewPartSymbolData",{R_:{custom_symbol_data:"Annotations.CustomSymbolData"}},1,1],[["custom_symbol_data","origin","leader"],"CreateCustomSymbol",{R_:{custom_symbol:"Annotations.CustomSymbol"}},3,1],[["custom_symbol_data","pmi_data","annotation_plane","origin","leader"],"CreatePmiCustomSymbol",{R_:{custom_symbol:"Annotations.PmiCustomSymbol"}},5,1],[[],"CreateSmashCustomSymbolBuilder",{R_:{builder:"Annotations.SmashCustomSymbolBuilder"}},0,0],[["masterSymbolTag"],"CreateMasterSymbolBuilder",{R_:{builder:"Annotations.MasterSymbolBuilder"}},1,0],[[],"CreateMasterSymbolListItemBuilder",{R_:{builder:"Annotations.MasterSymbolListItemBuilder"}},0,0],[["symbolTag"],"CreateDraftingCustomSymbolBuilder",{R_:{builder:"Annotations.DraftingCustomSymbolBuilder"}},1,0],[["symbolTag"],"CreatePmiCustomSymbolBuilder",{R_:{builder:"Annotations.PmiCustomSymbolBuilder"}},1,0],[["symbolTag"],"EditSymbolDisplayBuilder",{R_:{builder:"Annotations.EditSymbolDisplayBuilder"}},1,0],[["name"],"FindObject",{R_:{master:"Annotations.MasterSymbol"}},1,0],[[],"CreateSymbolCatalogBuilder",{R_:{builder:"Annotations.SymbolCatalogBuilder"}},0,0],[[],"CreateReplaceSymbolBuilder",{R_:{builder:"Annotations.ReplaceSymbolBuilder"}},0,0]],[]];
SPLM.Annotations.CustomSymbolCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Annotations.CustomSymbolCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;